<template>
    <div id="cartModal" ref="cartModal" class="modal fade" tabindex="-1" aria-labelledby="cartModal" aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full"
>
            <div class="modal-content select-none">
                <div class="modal-body mobile:!p-2.5 tablet:!p-3 !pb-5">
                    <div class="relative">
                        <button
type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal"
                            aria-label="Close" @click="cancelModal"
>
                            <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
                        </button>
                        <div class="relative rounded-lg overflow-hidden mobile:h-[70px] tablet:h-[100px]">
                            <img
src="../../assets/images/profile-bg.png" alt="Background"
                                class="w-full h-auto object-cover"
>
                            <div class="flex items-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
                                <div
class="flex items-center gap-2 rounded-full mobile:px-2 mobile:py-0.5 tablet:px-3 tablet:py-1 w-max bg-cyan-400"
                                    :class="{ '!bg-[#ccc]': modalCartCount == 0 }"
>
                                    <img
src="../../assets/images/cart-check-white.png" alt="Cart Icon"
                                        class="mobile:w-5 mobile:h-5 tablet:w-7 tablet:h-7"
>
                                    <span class="mobile:text-lg tablet:text-xl font-roboto font-bold text-white">{{
                                        modalCartCount
                                    }}</span>
                                </div>
                                <h4 class="text-xl m-0 font-roboto font-bold text-black-100">
Cart
</h4>
                            </div>
                        </div>
                    </div>
                    <div
                        class="responsiveOreitationCartHeightAdjust max-h-[75vh] desktop:max-h-[50vh] largeDesktop:max-h-[75vh] flex flex-col gap-[10px] pr-2 overflow-y-auto customScrollbar"
>
                        <!-- {{ cartDetails.bundles }} -->

                        <bundleCartCard
v-for="(bundle, index) in cartDetails.bundles" :key="index" :bundle="bundle"
                            :update-cart="updateBundleCart" :update-card="updateCardCart"
/>
                        <cartCard
v-for="(plan, index) in cartDetails.items" :key="index" :plan="plan"
                            :update-cart="updateCart" :update-card="updateCardCart"
/>

                        <div class="py-2 pr-2 text-right border-b border-gray-200">
                            <h6 class="m-0 mobile:text-sm tablet:text-base font-roboto font-semibold text-[#BA90C6]">
                                Total Amount
</h6>
                            <h2 class="m-0 mobile:text-xl tablet:text-3xl font-roboto font-bold  text-gray-950">
${{
                                $helper.formatAmount(cartItemsTotal) }}/mo
                            </h2>
                        </div>
                    </div>
                    <div class="sticky bottom-0 right-0 py-1.5 bg-white">
                        <button
class="px-3 py-1.5 flex justify-center items-center mx-auto gap-1 text-base rounded-full bg-[#FC819E] hover:!shadow-md"
                            @click="nrgModal(true)"
>
                            <span class="text-white">{{ cartDetails?.checkout_button_title ?? "Go to Enroll" }}</span>
                            <img src="../../assets/images/arrow-icon.png" class="w-7 h-7 object-contain" alt="icon">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import { ref } from 'vue';
import { mapActions, mapGetters } from "vuex";
import cartCard from '../cartCard/cartCard.vue';
import bundleCartCard from "../cartCard/bundleCartCard.vue";
import { globals } from "../../main";
export default {
    components: {
        cartCard,
        bundleCartCard
    },
    props: ["isCartUpdate"],
    data() {
        return {
            updateCard: null,
            updateCardCart: null,
            selectedPlan: {},
            selectedType: '',
            isFromOpenModal: false
        }
    },
    computed: {
        ...mapGetters([
            "cartDetails",
        ]),
        cartItemsTotal() {
            let total = 0
            if (this.cartDetails?.items?.length > 0) {
                total = this.cartDetails.items.reduce((sum, item) => sum + parseFloat(item.item_total_amount), 0);
            }

            if (this.cartDetails?.bundles?.length > 0) {
                total = total +  this.cartDetails?.bundles?.reduce((sum, item) => sum + parseFloat(item.bundle_amount), 0);
            }

            return total
        },
        modalCartCount() {
            // let totalQuantity = !this.$helper.isEmpty(this.cartDetails.items) ? this.cartDetails.items.reduce((sum, item) => sum + item.item_quantity, 0) : 0
            // return totalQuantity

            let totalQuantity = 0
            if (this.cartDetails?.items?.length > 0) {

                totalQuantity = totalQuantity + this.cartDetails?.items?.length;
            }

            if (this.cartDetails?.bundles?.length > 0) {

                totalQuantity = totalQuantity + this.cartDetails?.bundles?.length;
            }

            return totalQuantity
        }
    },
    watch: {

        cartDetails: function (data) {

            if (this.isFromOpenModal){
                this.isFromOpenModal = false
                if(this.cartDetails.bundles.length <= 0 && this.cartDetails.items.length <= 0 ){
                    this.$confirmDialog.show({
                        buttonText: "Refresh",
                        title: "Your Cart is Empty",
                        message: "Your cart has been cleared after completing checkout on another device or session. Please add new items to your cart in order to continue. Click refresh to update your cart view.",
                        onConfirm: () => {
                            globals.$loader.show();
                            window.location = window.location.href
                        },
                    });
                }
            }

            if(this.cartDetails.bundles.length <= 0 && this.cartDetails.items.length <= 0 ){
                    this.showModal = false                    
            }   

            const { Modal } = require('bootstrap');
                const modalEl = this.$refs.cartModal;
                this.modal = Modal.getInstance(modalEl);
                if (!this.modal) {
                    this.modal = new Modal(modalEl, {
                        backdrop: 'static',
                        keyboard: false
                    });
                }
                // Add event listeners for show/hide
                modalEl.addEventListener('show.bs.modal', () => {
                    document.documentElement.style.overflow = 'hidden'; // Target HTML element
                    if (window.innerWidth >= 992) {
                        document.documentElement.style.paddingRight = '15px';
                    } else {
                        document.documentElement.style.paddingRight = '0px';
                    }
                    this.adjustCartModalHeight();
                });
                modalEl.addEventListener('hidden.bs.modal', () => {
                    document.documentElement.style.overflow = ''; // Reset HTML element
                    document.documentElement.style.paddingRight = '0px';
                    window.removeEventListener('resize', this.adjustCartModalHeight);
                    window.removeEventListener('orientationchange', this.adjustCartModalHeight);
                });
                window.addEventListener('resize', this.adjustCartModalHeight);
                window.addEventListener('orientationchange', this.adjustCartModalHeight);

            if (this.showModal) {   
                this.modal.show();
            }
            if (!this.showModal) {
                this.modal.hide();
            }
            this.$refs.cartModal.addEventListener('hidden.bs.modal', this.onCartModalClose);
        },

    },
    methods: {
        ...mapActions([
            "getCartDetails",
            "getCartCount",

        ]),

        nrgModal(){
            if(this.modal){
                this.modal.hide();
            }
            this.cancelModal()
            this.$emit('event' ,'' ,'' , 'nrg')
        },

        adjustCartModalHeight() {
            const modalContent = this.$refs.cartModal?.querySelector('.responsiveOreitationCartHeightAdjust');
            if (modalContent) {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 400) {
                    maxHeight = vh * 0.4 - 40;
                } else if (vw < 768) {
                    maxHeight = vh * 0.5 - 40;
                } else if (vw < 1024) {
                    maxHeight = vh * 0.5 - 30;
                } else {
                    maxHeight = vh * 0.4 - 40;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            }
        },
    
        updateBundleCart(option, plan) {
            this.$emit('event' , option,plan , 'bundle', 'update')

        },
        updateCart(option, plan , type) {
            if(type == 'plan'){
                this.$emit('event' , option,plan , 'plan' , '')
            }
            else{
                this.$emit('event' , option,plan , 'bundle', 'update')
            }
        },
        
        openCartModal() {
            // alert("Open cart Modal")
            // if (this.cartModal == null || (this.cartCount && this.cartCount.items_count > 0)) {
            //     this.getCartDetails({})
            // }
            this.isFromOpenModal = true
            this.showModal  = true
            this.getCartDetails({})
            
        },
        hideModal() {
         //   alert('hide')
            const modalEl = this.$refs.cartModal;
            this.modal = Modal.getInstance(modalEl);

            if(this.modal){
                this.modal.hide();

            }
        },
        cancelModal(){
            this.showModal  = false
        }
    }
}
</script>